<template>
  <div>
    <div class="page-header">
      <span class="h3">{{ $t("projects.parent") }}</span>
      <router-link :to="$t('categories.route')"><span class="h6 text-muted float-right">Manage {{ $t("categories.plural") }}</span></router-link>
      <span v-if="allArchivedProjects.length">
        <br /><router-link :to="$t('projects.archived_route')"><span class="h6 text-muted float-right">{{ $t("projects.parent") }} Archive</span></router-link>
      </span>
    </div>

    <ul class="list-style-none p-0">
        <li v-for="(project_area, project_area_index) in projectAreas">
          <div class="h4 mt-2 mb-2">
            {{project_area.name}}
          </div>

          <draggable :data-project-area-id="project_area.id" class="dragArea list-group" :list="project_area.projects" :options="{group:'projects', delay:200}" @change="log" @add="add"  handle=".sort-handle">
            <li v-for="project in project_area.projects" :key="project.id" :data-project-id="project.id" class="list-group-item">
              <span class=" d-flex">
                <ProjectTitle :project=project />
                <span class='push-right'>
                  <i class="material-icons pointer ml-1 sort-handle">reorder</i>
                </span>
              </span>
            </li>
        </draggable>
        </li>
      </ul>
  </div>
</template>

<script>
var firstBy = require('thenby');
import api from "api";
import QuickTask from "components/QuickTask";
import ProjectTitle from "components/ProjectTitle";
import NewQuickTask from "components/NewQuickTask";
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    ProjectTitle,
    draggable
  },
  computed: {
    projectAreas: {
      get() {
        return this.$store.state.project_areas.filter(area => {
          return area.file_cabinet === false
        })
      }
    },
    allArchivedProjects: {
      get: function() {
        return this.$store.state.archived_projects
      }
    }
  },
  methods: {
    log: function(evt) {
      if(evt.moved){
        api.changeProjectSort(evt.moved.element.id, evt.moved.newIndex)
      }
    },
    add: function(evt) {
      api.moveProject(evt.item.dataset.projectId, evt.to.dataset.projectAreaId, evt.newIndex)
    },
    deleteProjectArea(project_area) {
      api.deleteProjectArea(project_area.id).then(response => {
        $('body').removeClass('modal-open')
        $(".modal-backdrop").hide();
      });
    },
    updateProjectArea(project_area) {
      if(project_area.name){
        api.updateProjectArea(project_area.id, { name: project_area.name }).then(response => {
          $('#editProjectAreaModal' + project_area.id).modal('hide')
        });
      }
    }
  }  
};
</script>
